var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-07607522-b4ef-4862-9705-652e7e6e620d",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 931.11 1391.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-2247479e-5e2c-4efb-9da6-c147eaa05118 {\n        fill: #ffb401;\n      }\n\n      .uuid-77a9cab9-cafe-486a-b70c-50699991232b {\n        fill: #4d4d4d;\n      }\n\n      .uuid-5811eb8b-6d90-45bf-8922-9f6fc6ac49c4 {\n        fill: #fed201;\n      }\n\n      .uuid-365a7290-c468-4d40-a934-3f90a496af4a {\n        fill: #fff;\n      }\n\n      .uuid-a7bee15f-7439-4617-86bd-96f56e42f84c {\n        fill: #666;\n      }\n\n      .uuid-fa99ec23-ffdf-4456-8f90-6691964c88b9 {\n        fill: #fec701;\n      }\n\n      .uuid-2e66d982-5fc3-48d3-9e61-ef9520cb6b58 {\n        fill: #333;\n      }\n\n      .uuid-c4c17901-e32a-4d1d-933c-44c2f2204f5a {\n        fill: none;\n        stroke: #ffb401;\n        stroke-miterlimit: 10;\n        stroke-width: 32.94px;\n      }\n\n      .uuid-23e76dd0-a83e-4de9-89e6-a09c9c0984c0 {\n        fill: #1a1a1a;\n      }\n\n      .uuid-35a22d90-371b-46d5-8567-d7ed2e0c9a8e {\n        fill: #fee676;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-eba77696-886e-4b9a-8214-e201d452817f",
    "data-name": "artwork"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-c4c17901-e32a-4d1d-933c-44c2f2204f5a",
    d: "M690.35,354.67h185.46c25.36,0,43.91,23.93,37.59,48.49l-35.11,136.4c-16.32,63.4-73.48,107.71-138.95,107.71h-153.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c4c17901-e32a-4d1d-933c-44c2f2204f5a",
    d: "M240.76,354.67H55.3c-25.36,0-43.91,23.93-37.59,48.49l35.12,136.4c16.32,63.4,73.48,107.71,138.94,107.71h153.34"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-2247479e-5e2c-4efb-9da6-c147eaa05118",
    d: "M465.56,852.77h-36.63c14.09-21.6,1.61-57.59-22.14-81.98h58.77v81.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-2247479e-5e2c-4efb-9da6-c147eaa05118",
    d: "M465.56,852.77h36.63c-14.09-21.6-1.61-57.59,22.14-81.98h-58.77v81.98Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-2247479e-5e2c-4efb-9da6-c147eaa05118",
    d: "M465.56,852.77h-36.63c14.09,21.6,1.61,57.59-22.14,81.98h58.77v-81.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-2247479e-5e2c-4efb-9da6-c147eaa05118",
    d: "M465.56,852.77h36.63c-14.09,21.6-1.61,57.59,22.14,81.98h-58.77v-81.98Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-2247479e-5e2c-4efb-9da6-c147eaa05118",
    x: 406.78,
    y: 934.74,
    width: 117.54,
    height: 82.86
  })), /*#__PURE__*/React.createElement("path", {
    className: "uuid-fa99ec23-ffdf-4456-8f90-6691964c88b9",
    d: "M486.55,852.77c-9.64-21.6-1.1-57.59,15.15-81.98h-40.21s-40.21,0-40.21,0c16.25,24.39,24.79,60.37,15.15,81.98,9.64,21.6,1.1,57.59-15.15,81.98v82.86h80.42v-82.86c-16.25-24.39-24.79-60.37-15.15-81.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-2247479e-5e2c-4efb-9da6-c147eaa05118",
    d: "M631.24,1103.67h-331.37c-5.69,0-9.11-6.32-5.99-11.08l15.26-23.31c22.92-35.03,56.94-61.35,96.6-74.74h0c38.8-13.1,80.83-13.1,119.64,0h0c39.66,13.4,73.68,39.72,96.6,74.74l15.26,23.31c3.12,4.76-.3,11.08-5.99,11.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-fa99ec23-ffdf-4456-8f90-6691964c88b9",
    d: "M596,1096.75h-268.51c-4.61,0-7.38-6.13-4.85-10.75l12.36-22.61c18.57-33.97,46.14-59.5,78.28-72.49h0c31.44-12.71,65.5-12.71,96.94,0h0c32.14,12.99,59.7,38.52,78.28,72.49l12.36,22.61c2.53,4.62-.24,10.75-4.85,10.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5811eb8b-6d90-45bf-8922-9f6fc6ac49c4",
    d: "M464.88,982.28c-78.06,19.82-110.58,103.73-110.58,103.73-2.24,4.62.21,10.75,4.3,10.75h50.21c-4.67,0-14.89-57.24,56.07-114.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5811eb8b-6d90-45bf-8922-9f6fc6ac49c4",
    d: "M459.35,852.77c-2.18-21.6-.25-57.59,3.43-81.98h-9.1s-9.1,0-9.1,0c3.68,24.39,5.61,60.37,3.43,81.98,2.18,21.6.25,57.59-3.43,81.98v57.55l18.2-8.95v-48.6c-3.68-24.39-5.61-60.37-3.43-81.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-2247479e-5e2c-4efb-9da6-c147eaa05118",
    d: "M406.78,770.79c13.67,14.04,23.57,31.91,26.85,48.68,6.86,1.75,13.5,3.14,19.8,4.06h24.23c6.3-.91,12.94-2.3,19.8-4.06,3.29-16.77,13.18-34.64,26.85-48.68h-58.77s-58.77,0-58.77,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-fa99ec23-ffdf-4456-8f90-6691964c88b9",
    d: "M759.49,255.02c-2.5-22.24-21.14-39.18-43.53-39.18H215.15c-22.38,0-41.03,16.94-43.53,39.18-41.27,367.56,169.53,514.81,281.82,531.09h24.23c112.29-16.27,323.09-163.52,281.82-531.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5811eb8b-6d90-45bf-8922-9f6fc6ac49c4",
    d: "M682.18,255.02c-2.05-22.24-17.38-39.18-35.77-39.18H234.81c-18.4,0-33.72,16.94-35.77,39.18-33.92,367.56,139.33,514.81,231.62,531.09h19.92c92.29-16.27,265.54-163.52,231.62-531.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-35a22d90-371b-46d5-8567-d7ed2e0c9a8e",
    d: "M351.89,250.76c1.35-19.84,12.79-34.92,26.34-34.92h-109.16c-13.54,0-24.82,15.1-26.34,34.92-20.56,269.76,62.29,406.38,130.12,454.31,13.95,9.86,32.53-3.35,27.58-19.7-22.03-72.81-63.95-208.13-48.53-434.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-fa99ec23-ffdf-4456-8f90-6691964c88b9",
    d: "M729.34,215.83H201.77c-23.61,0-43.23,17.88-45.86,41.34-.77,6.84-1.45,13.61-2.05,20.3-.75,8.38,5.95,15.54,14.36,15.54h594.67c8.41,0,15.11-7.17,14.36-15.54-.6-6.7-1.28-13.46-2.05-20.3-2.63-23.46-22.25-41.34-45.86-41.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5811eb8b-6d90-45bf-8922-9f6fc6ac49c4",
    d: "M630.12,215.83H209.83c-18.81,0-34.44,17.88-36.53,41.34-.61,6.84-1.16,13.61-1.64,20.3-.6,8.38,4.74,15.54,11.44,15.54h473.75c6.7,0,12.04-7.17,11.44-15.54-.48-6.7-1.02-13.46-1.63-20.3-2.1-23.46-17.73-41.34-36.53-41.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-35a22d90-371b-46d5-8567-d7ed2e0c9a8e",
    d: "M225.68,250.76c-1.11,14.49-1.85,28.53-2.38,42.26h109.28c.54-13.72,1.28-27.8,2.27-42.26,1.35-19.84,12.79-34.92,26.33-34.92h-109.16c-13.54,0-24.83,15.1-26.34,34.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-2247479e-5e2c-4efb-9da6-c147eaa05118",
    d: "M167.23,312.31h596.65c-.31-7.02-.62-14.04-1.13-21.25H168.36c-.51,7.2-.82,14.22-1.13,21.25Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "uuid-2247479e-5e2c-4efb-9da6-c147eaa05118",
    cx: 465.56,
    cy: 500.97,
    r: 128.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-365a7290-c468-4d40-a934-3f90a496af4a",
    d: "M472.54,429.74l16.3,33.02c1.14,2.3,3.33,3.89,5.87,4.26l36.44,5.3c6.39.93,8.94,8.78,4.32,13.29l-26.37,25.7c-1.84,1.79-2.67,4.37-2.24,6.9l6.23,36.29c1.09,6.36-5.59,11.22-11.31,8.21l-32.59-17.13c-2.27-1.19-4.98-1.19-7.25,0l-32.59,17.13c-5.72,3.01-12.4-1.85-11.3-8.21l6.22-36.29c.43-2.53-.4-5.11-2.24-6.9l-26.37-25.7c-4.62-4.51-2.07-12.36,4.32-13.29l36.44-5.3c2.54-.37,4.73-1.96,5.87-4.26l16.3-33.02c2.86-5.79,11.12-5.79,13.97,0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5811eb8b-6d90-45bf-8922-9f6fc6ac49c4",
    d: "M874.14,264.95h0c0-27.12-21.99-49.11-49.11-49.11h0c27.12,0,49.11-21.99,49.11-49.11h0c0,27.12,21.99,49.11,49.11,49.11h0c-27.12,0-49.11,21.99-49.11,49.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5811eb8b-6d90-45bf-8922-9f6fc6ac49c4",
    d: "M194.69,852.77h0c0-27.12-21.99-49.11-49.11-49.11h0c27.12,0,49.11-21.99,49.11-49.11h0c0,27.12,21.99,49.11,49.11,49.11h0c-27.12,0-49.11,21.99-49.11,49.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5811eb8b-6d90-45bf-8922-9f6fc6ac49c4",
    d: "M444.57,98.23h0c0-27.12-21.99-49.11-49.11-49.11h0c27.12,0,49.11-21.99,49.11-49.11h0c0,27.12,21.99,49.11,49.11,49.11h0c-27.12,0-49.11,21.99-49.11,49.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5811eb8b-6d90-45bf-8922-9f6fc6ac49c4",
    d: "M92.14,205.31h0c0-16.01-12.98-28.99-28.98-28.99h0c16.01,0,28.98-12.98,28.98-28.99h0c0,16.01,12.98,28.99,28.99,28.99h0c-16.01,0-28.99,12.98-28.99,28.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5811eb8b-6d90-45bf-8922-9f6fc6ac49c4",
    d: "M524.33,170.54h0c0-16.01-12.98-28.99-28.99-28.99h0c16.01,0,28.99-12.98,28.99-28.99h0c0,16.01,12.98,28.99,28.99,28.99h0c-16.01,0-28.99,12.98-28.99,28.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5811eb8b-6d90-45bf-8922-9f6fc6ac49c4",
    d: "M706.8,766.43h0c0-16.01-12.98-28.99-28.99-28.99h0c16.01,0,28.99-12.98,28.99-28.99h0c0,16.01,12.98,28.99,28.99,28.99h0c-16.01,0-28.99,12.98-28.99,28.99Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "uuid-77a9cab9-cafe-486a-b70c-50699991232b",
    x: 240.9,
    y: 1103.94,
    width: 449.22,
    height: 230.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-2247479e-5e2c-4efb-9da6-c147eaa05118",
    d: "M330.56,1158.21h270c11.13,0,20.16,9.04,20.16,20.16v81.49c0,11.13-9.04,20.16-20.16,20.16h-269.99c-11.13,0-20.17-9.04-20.17-20.17v-81.49c0-11.13,9.04-20.16,20.16-20.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-fa99ec23-ffdf-4456-8f90-6691964c88b9",
    d: "M424.8,1070.78h81.5c7.3,0,13.22,5.93,13.22,13.22v269.99c0,7.29-5.92,13.22-13.22,13.22h-81.5c-7.29,0-13.22-5.92-13.22-13.22v-270c0-7.29,5.92-13.22,13.22-13.22Z",
    transform: "translate(1684.55 753.44) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-2e66d982-5fc3-48d3-9e61-ef9520cb6b58",
    x: 240.9,
    y: 1109.58,
    width: 449.22,
    height: 35.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5811eb8b-6d90-45bf-8922-9f6fc6ac49c4",
    d: "M421.94,1272.96h-67.51v-107.93h67.51v107.93s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-a7bee15f-7439-4617-86bd-96f56e42f84c",
    d: "M226.88,1091.44h477.41c4.07,0,7.37,3.3,7.37,7.37v20.55c0,4.07-3.3,7.37-7.37,7.37H226.88c-4.07,0-7.37-3.3-7.37-7.37v-20.55c0-4.07,3.3-7.37,7.37-7.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-23e76dd0-a83e-4de9-89e6-a09c9c0984c0",
    d: "M195.33,1339.01v41.4c0,6.38,5.17,11.56,11.56,11.56h517.35c6.38,0,11.56-5.17,11.56-11.56v-41.4H195.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-2e66d982-5fc3-48d3-9e61-ef9520cb6b58",
    d: "M212.3,1319.65l-16.98,19.36h540.46l-16.98-19.36c-4.57-5.21-11.17-8.2-18.1-8.2H230.41c-6.93,0-13.53,2.99-18.1,8.2Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-2e66d982-5fc3-48d3-9e61-ef9520cb6b58",
    d: "M606.85,1179.86c0,3.59-2.91,6.5-6.5,6.5s-6.5-2.91-6.5-6.5,2.91-6.5,6.5-6.5,6.5,2.91,6.5,6.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "uuid-a7bee15f-7439-4617-86bd-96f56e42f84c",
    x: 599.75,
    y: 1175.66,
    width: 1.19,
    height: 8.4,
    transform: "translate(-658.45 770.08) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-a7bee15f-7439-4617-86bd-96f56e42f84c",
    x: 596.15,
    y: 1179.26,
    width: 8.4,
    height: 1.19,
    transform: "translate(-658.45 770.08) rotate(-45)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-2e66d982-5fc3-48d3-9e61-ef9520cb6b58",
    d: "M606.85,1258.14c0,3.59-2.91,6.5-6.5,6.5s-6.5-2.91-6.5-6.5,2.91-6.5,6.5-6.5,6.5,2.91,6.5,6.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "uuid-a7bee15f-7439-4617-86bd-96f56e42f84c",
    x: 596.15,
    y: 1257.54,
    width: 8.4,
    height: 1.19,
    transform: "translate(1065.47 -56.01) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-a7bee15f-7439-4617-86bd-96f56e42f84c",
    x: 596.15,
    y: 1257.54,
    width: 8.4,
    height: 1.19,
    transform: "translate(1914.49 1723.26) rotate(135)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-2e66d982-5fc3-48d3-9e61-ef9520cb6b58",
    d: "M337.27,1179.86c0,3.59-2.91,6.5-6.5,6.5s-6.5-2.91-6.5-6.5,2.91-6.5,6.5-6.5,6.5,2.91,6.5,6.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "uuid-a7bee15f-7439-4617-86bd-96f56e42f84c",
    x: 326.57,
    y: 1179.26,
    width: 8.4,
    height: 1.19,
    transform: "translate(931.16 111.68) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-a7bee15f-7439-4617-86bd-96f56e42f84c",
    x: 326.57,
    y: 1179.26,
    width: 8.4,
    height: 1.19,
    transform: "translate(1398.94 1780.26) rotate(135)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-2e66d982-5fc3-48d3-9e61-ef9520cb6b58",
    d: "M337.27,1258.14c0,3.59-2.91,6.5-6.5,6.5s-6.5-2.91-6.5-6.5,2.91-6.5,6.5-6.5,6.5,2.91,6.5,6.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "uuid-a7bee15f-7439-4617-86bd-96f56e42f84c",
    x: 326.57,
    y: 1257.54,
    width: 8.4,
    height: 1.19,
    transform: "translate(986.52 134.61) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-a7bee15f-7439-4617-86bd-96f56e42f84c",
    x: 326.57,
    y: 1257.54,
    width: 8.4,
    height: 1.19,
    transform: "translate(1454.29 1913.88) rotate(135)"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.b4adb0ae339b7daa1028766ceb9de45a.svg";
export { ForwardRef as ReactComponent };